import moment from 'moment-timezone';

import createSelector from 'web-app/util/custom-create-selector';
import ProductsAndSessionsBehaviors from 'web-app/behaviors/products-and-sessions-behavior-ids';

import Session from './model';

const validTo = (_, props) =>
    props && props.validTo && moment.isMoment(props.validTo) ? props.validTo.clone() : moment().startOf('day');

const validFrom = (_, props) =>
    props && props.validFrom && moment.isMoment(props.validFrom) ? props.validFrom.clone() : moment();

const dayFromProps = (_, props) => (props ? props.day : null);

const sessionIdFromProps = (_, props) => (props ? props.sessionId : null);

const filterStandaloneAndVolumeSessions = sessions =>
    sessions.filter(
        s =>
            s.sessionType === Session.SessionType.STANDALONE_SESSION ||
            s.sessionType === Session.SessionType.VOLUME_SESSION,
    );

const filterPackages = sessions => sessions.filter(s => s.sessionType === Session.SessionType.PACKAGE_SESSION);

export const getSessionsState = state => state.entities.sessions;
export const getBehaviorState = state => state.entities.sessionBehaviors;

export const getAllValidAndInvalidSessions = createSelector(getSessionsState, filterStandaloneAndVolumeSessions);

export const getAllValidAndInvalidPackages = createSelector(getSessionsState, filterPackages);

export const getAllSessionVersions = createSelector(getSessionsState, sessionIdFromProps, (sessions, sessionId) =>
    sessions
        .filter(session => session.sessionId === sessionId)
        .toList()
        .sortBy(session => session.validFrom.toDate()),
);

export const getValidSessions = createSelector(getSessionsState, validTo, validFrom, (sessions, validTo, validFrom) =>
    sessions.filter(s => {
        const to = s.validTo ? s.validTo.isAfter(validTo) : true;
        const from = s.validFrom ? s.validFrom.isSameOrBefore(validFrom) : true;
        return from && to;
    }),
);

export const getStandaloneSessionsMap = createSelector(getValidSessions, filterStandaloneAndVolumeSessions);

export const getStandaloneSessions = createSelector(getStandaloneSessionsMap, sessions => sessions.toList());

export const getStandaloneSessionsByInstitutionId = createSelector(
    getStandaloneSessions,
    (state, props) => props.institutionId,
    (sessions, institutionId) => {
        return sessions.filter(s => s.institutionId === institutionId);
    },
);

export const getSessionsInADay = createSelector(getStandaloneSessions, dayFromProps, (sessions, day) =>
    sessions.filter(s => s.availability.some(av => av.day === day)),
);

const makeGetSessionByProps = () => {
    return createSelector(
        getSessionsState,
        (state, props) => props.sessionVersion,
        (sessions, itemId) => sessions.get(itemId),
    );
};

export const showWeekends = createSelector(getBehaviorState, behaviors =>
    behaviors.includes(ProductsAndSessionsBehaviors.ShowWeekend),
);

export const getSessionByProps = makeGetSessionByProps();

export const canUseVolumePricing = createSelector(getBehaviorState, behaviors =>
    behaviors.includes(ProductsAndSessionsBehaviors.CanUseVolumePricing),
);

export const canUsePackages = createSelector(getBehaviorState, behaviors =>
    behaviors.includes(ProductsAndSessionsBehaviors.CanUsePackages),
);
